import { Route } from "@angular/router";
import { EADPage } from "./ead.page";

export const EADRouter: Route[] = [
  { path: 'ead', component: EADPage }
];
